import { ButtonLoader, Form } from '@wellesley/ui'
import { FC, useEffect } from 'react'
import {
  usernameMaxLength,
  useCommonForm,
  usernameValidator,
} from '@wellesley/forms'
import zod from 'zod'
import CommonFormField from 'components/form/CommonFormField'

type UpdateUsernameViewProps = {
  error?: string
  isLoading: boolean
  onSave: (username: string) => void
}

export const UpdateUsernameView: FC<UpdateUsernameViewProps> = ({
  error,
  isLoading,
  onSave,
}) => {
  const form = useCommonForm({
    schema: zod.object({
      username: usernameValidator({ showInlineError: true }),
    }),
  })

  const { control, handleSubmit } = form

  useEffect(() => {
    if (error) {
      form.setError('username', { message: error })
    }
  }, [error, form])

  return (
    <Form {...form}>
      <form
        onSubmit={(...args) =>
          void handleSubmit((data) => onSave(data.username))(...args)
        }
      >
        <div className="mx-auto flex w-[450px] flex-col items-center justify-center gap-m rounded-lg bg-white">
          <h1 className="w-full border-b border-gray-200 py-m text-center text-lg font-semibold text-gray-700">
            Choose a new username
          </h1>
          <div className="flex flex-col gap-s px-m">
            <p className="py-xs text-center text-base font-medium text-gray-500">
              To complete your account setup choose a new username
            </p>
            <CommonFormField
              name="username"
              control={control}
              displayName="New username"
              maxChars={usernameMaxLength}
            />
          </div>
          <div className="flex w-full justify-end px-m pb-m">
            <ButtonLoader
              isLoading={isLoading}
              size="m"
              variant="primary"
              type="submit"
              disabled={!form.formState.isValid}
            >
              Save
            </ButtonLoader>
          </div>
        </div>
      </form>
    </Form>
  )
}
